import styled from "styled-components";

export const SelectionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
gap: 15px;
`;